<!-- Modal Wrapper - Prevents backdrop clicks from closing modal -->
<div class="default-sourcing-modal-wrapper" (click)="$event.stopPropagation()">
<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div class="panel panel-default">
    <div class="panel-body">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="tax-year"><b>Tax Year:</b></label>
            <input type="text" class="form-control" id="tax-year" name="tax-year" placeholder=""
              [(ngModel)]="overrideEntity.TAX_YEAR" readonly>
          </div>
          @if (overrideEntity.TAX_YEAR_NOT_VALID && !overrideEntity.TAX_YEAR) {
<small class="text-danger">
            Please provide To Tax Year
          </small>
}
        </div>

        <div class="col-md-6">
          <label for="scenario-type-1"><b>HO LEID/ Reporting Period:<sup>*</sup>:</b></label>
          <select class="form-control" id="scenario-type-1" [(ngModel)]="overrideEntity.HO_LEID_RP" [disabled]="isEdit">
            <option value="">-- Select --</option>
            @for (option of ho_leid_RP_options; track $index) {
<option [value]="option.HO_LEID_RP">
              {{option.HO_LEID_RP}}
            </option>
}
          </select>
          @if (overrideEntity.HO_LEID_RP_NOT_VALID && !overrideEntity.HO_LEID_RP) {
<small class="text-danger">
            Please provide HO LEID/ Reporting Period
          </small>
}
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <label for="scenario-desc"><b>Override Basket:<sup>*</sup></b></label>
          <select class="form-control" id="scenario-desc" [(ngModel)]="overrideEntity.BASKET"
            (ngModelChange)="updateBasket()">
            <option value="">-- Select --</option>
            @for (option of basket_options; track $index) {
<option [value]="option.BASKET">
              {{option.BASKET}}
            </option>
}
          </select>
          @if (overrideEntity.BASKET_NOT_VALID && !overrideEntity.BASKET) {
<small class="text-danger">
            Please provide Basket value
          </small>
}
        </div>

        <div class="col-md-6">
          <label for="scenario-type"><b>FSI Key:</b></label>
          <input type="text" class="form-control" id="scenario-type" name="scenario-type" placeholder=""
            [(ngModel)]="overrideEntity.FSI_KEY" disabled>
        </div>
      </div>
    </div>
  </div>
}
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button class="save-button" 
          type="button" 
          (click)="save()" 
          [disabled]="isSaveClicked || crudLoading"> 
    @if (isSaveClicked || crudLoading) {
<span>
      <i class="fa fa-spinner fa-pulse"></i>
    </span>
}
    Save
  </button>
  <button class="reset-button" 
          type="button" 
          (click)="reset()">
    Reset
  </button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">
    Cancel
  </button>
</div>
</div>
<!-- End Modal Wrapper -->